
        export const insertDummyFunctions = () => {window.newVuukleWidgets=window.newVuukleWidgets||function(e){window.tempVuukleWidgets=e};};
        export const loadLegacyPlatform = () => {
    $lvpl('https://cdntest.vuukle.com/platform.legacy.js');
    function $lvpl(src) {
      if (typeof ''.matchAll !== 'undefined') {
        return true;
      } else {
        delete window.VUUKLE_PLATFORM;
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        document.head.appendChild(s);
        return false;
      }
    }
  };
      